import React, { useState } from "react";
import HollowButton from "../../components/customComponents/HallowButton";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { setPaymentMethodModal } from "../../reducer/modalReducer";
import PaymentMethodModal from "../../components/Modal/PaymentMethodModal";

export default function PATPaymentMethodSection() {
  const dispatch = useDispatch();
  const { paymentMethod } = useSelector(
    (state: RootState) => state.registration
  );

  const handleEditButtonClick = () => {
    dispatch(setPaymentMethodModal(true));
  };

  return (
    <div className={Classname.container}>
      <PaymentMethodModal />
      <div className={Classname.flexBetween}>
        <div className="font-semibold mb-3">Payment method</div>
        <HollowButton label="Edit" onClick={handleEditButtonClick} />
      </div>

      <div className={Classname.listContainer}>
        <div className={Classname.title}>Payment method</div>
        {paymentMethod ? (
          <div>{paymentMethod}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>
    </div>
  );
}

const Classname = {
  container: "bg-white pb-10 rounded-md p-2 h-fit gap-3 flex flex-col lg:px-10",
  flexBetween: "flex justify-between mt-5",
  title: "font-bold w-56",
  listContainer: "flex lg:gap-32 flex-col lg:flex-row",
  unspecified: "text-red-500 ",
};
